import React from "react";
import { getAwsAssets } from "@src/utils";
import styles from "../../../styles/DownloadIcon.module.scss";
import { Image } from "@src/components/Image";
import { t } from "i18next";

const DownloadIcon = ({ onClick , isTextVisible = false}) => {
  const handleDownloadClicked = (e) => {
    e?.stopPropagation();
    onClick && onClick();
  };

  return (
    <div className={styles.downloadIcon} onClick={handleDownloadClicked}>
      <div
        className={styles.downloadIcon__icon}
        onClick={handleDownloadClicked}
      >
        <Image
          src={getAwsAssets("downArrowIcon.svg", "content")}
          alt="downArrowIcon"
          height={8}
          width={8}
        />
      </div>
      <span>{ isTextVisible && t(
          "components.tabs.content.components.contentList.listItem.downloadText",
          "Download"
        )}</span>
    </div>
  );
};

export default DownloadIcon;
